import { ReturnedError } from "@/types";

export const isBackendError = (error: ReturnedError) => {
    return "response" in error && "data" in error.response;
};

export const isFrontendError = (error: ReturnedError) => {
    return "message" in error;
};
